/*
===============================================================================================================
                                 Copyright 2025-2025, Blue Yonder Group, Inc.
                                              All Rights Reserved

                                THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
                                            BLUE YONDER GROUP, INC.

                            The copyright notice above does not evidence any actual
                                 or intended publication of such source code.

===============================================================================================================
*/

import AUSTRALIA_POST from './australia_post.json';
import USPS from './usps.json';
import YAMATO from './yamato.json';
import BLUE_YONDER from './blue_yonder.json';
import DEFAULT from './default.json';

export default {
  AUSTRALIA_POST,
  USPS,
  YAMATO,
  BLUE_YONDER,
  DEFAULT,
};
